import { useState } from 'react';
import './PanManual.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

let PanManual=(props)=>{
    let navigate = useNavigate();
    let [inputs, setinputs]= useState({});
    let [photo, setphoto]=useState(null); 
    let [sig, setsig]=useState(null);
    let [qr, setqr]=useState(null);
     
    let photofun=(e)=>{
        if(e.target.files && e.target.files[0]){
            setphoto(URL.createObjectURL(e.target.files[0]))
        }
    }
    let sigfun=(e)=>{
        if(e.target.files && e.target.files[0]){
            setsig(URL.createObjectURL(e.target.files[0]))
        }
    }
    let qrfun=(e)=>{
        if(e.target.files && e.target.files[0]){
            setqr(URL.createObjectURL(e.target.files[0]))
        }
    }
    let inputchangehandler =(e)=>{
        let name = e.target.name;
        let value = e.target.value;
        setinputs(values=> ({...values, [name] : value}))
    }
    let pansubmitfun=()=>{
        let panData={
            name: inputs.name,
            pannumber: inputs.pannumber,
            fathername: inputs.fathername,
            dob: inputs.dob,
            photo: photo,
            sig: sig,
            qr: qr
        }
        if(panData.name==undefined){
            props.Successandrerrorfun("","Name Required");
            return;
        }else if(panData.pannumber==undefined){
            props.Successandrerrorfun("","Pan number required");
            return;
        }else if(panData.fathername==undefined){
            props.Successandrerrorfun("","Father name required");
            return;
        }else if(panData.dob==undefined){
            props.Successandrerrorfun("","Date of birth is required");
            return
        }else if(panData.photo==null){
            props.Successandrerrorfun("","Photo required");
            return;
        }else if(panData.qr==null){
            props.Successandrerrorfun("","Qr is required")
            return;
        }
        props.gotpandata(panData);
         navigate('/panprintManual');
    }



    return(
        <div className='panmanualmaincont'> 
            <h1 className='panheadhin'>PRINT PAN CARD MANUALLY</h1>
            <div className='photoandqrcont'>
                <label className='photolabel' htmlFor='photo'>Upload Photo</label>
                <input onChange={photofun} style={{display:"none"}} id='photo' type='file'/>
                <label  className='photolabel'  htmlFor='qr'>Upload QR</label>
                <input onChange={qrfun}  style={{display:"none"}}  id='qr' type='file'/>
                <label  className='photolabel'  htmlFor='sig'>Signature</label>
                <input onChange={sigfun}  style={{display:"none"}}  id='sig' type='file'/>
            </div> 
            <div className='pandetailscont'>
                <input name='name' onChange={inputchangehandler} type='text' placeholder='Name on pan'/>
                <input name='pannumber' onChange={inputchangehandler} type='text' placeholder='Pan card Number'/>
                <input name='fathername' onChange={inputchangehandler} type='text' placeholder='Fathers/Mother"s" name'/>
                <input name='dob' onChange={inputchangehandler} type='text' placeholder='Date of Birth'/>
            </div>
            <div className='buncont'>
                <button onClick={pansubmitfun}><a style={{color:"white"}} >Submit</a></button>
            </div>
            
        </div>
    );
}
export default PanManual; 